import React from "react";
import { Mail, MessageSquare } from "lucide-react";
import { InfoLayout } from "@/components/InfoLayout";
import { useLanguage } from "@/context/LanguageContext";

export default function Contact() {
  const { t, language } = useLanguage();
  const body = language === "hi"
    ? "सवाल, सुझाव या मदद चाहिए? हमें ईमेल करें और हम जल्द उत्तर देंगे।"
    : "Questions, feedback, or need help? Email us and we'll get back to you soon.";
  return (
    <InfoLayout title={t("contact_title")} subtitle={t("contact_subtitle")} testId="contact-page">
      <p>{body}</p>
      <a href="mailto:evermin1999@gmail.com" data-testid="contact-email" className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-3 font-medium text-primary hover:border-primary/40">
        <Mail className="h-4 w-4" /> evermin1999@gmail.com
      </a>
      <div className="flex items-start gap-2 rounded-xl bg-slate-50 p-4 text-sm text-slate-500">
        <MessageSquare className="mt-0.5 h-4 w-4 flex-shrink-0" />
        {language === "hi"
          ? "यह एक डेमो संपर्क पता है। कृपया संवेदनशील व्यक्तिगत जानकारी साझा न करें।"
          : "For any questions or support, feel free to contact us by email."}
      </div>
    </InfoLayout>
  );
}
